import React from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";
import { isUnregistered } from "utils/isUnregistered";

const MaximumPasswordsReached = ({ modalContent, closeModal, historyLinkClick, historyLinkRole }) => {
  return (
    <Modal contentLabel="maximum passwords modal" visibleModal closeModal={closeModal}>
      <Container>
        <H2>{modalContent.section_title}</H2>
        <Div>{convertStringToElements(modalContent.section_description)}</Div>
        <div>
          <div style={{ marginTop: "30px" }}>
            <Button onClick={closeModal} background={modalContent.buttons[0].type}>
              {modalContent.buttons[0].text}
            </Button>

            {!isUnregistered() ? (
              <HistoryLink onClick={historyLinkClick} role={historyLinkRole ? historyLinkRole : "button"}>
                {modalContent.links[0].text}
              </HistoryLink>
            ) : null}
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default MaximumPasswordsReached;

const Container = styled.div`
  max-width: 361px;
  padding-right: 70px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const Div = styled.div`
  p {
    padding: 10px 0;
  }
`;

const H2 = styled.h2`
  margin-bottom: 10px;
`;

const HistoryLink = styled.button`
  display: inline-block;
  margin-left: 25px;
  border: 0;
  background: 0;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;

  ${media.mobile`
    display: block;
    text-align: center;
    margin-left: 0;
    margin-top: 15px;
  `}
`;
